const testimonials = [
  {
    name: "James K.",
    location: "Eden Prairie, MN",
    rating: 5,
    text: "I work at a medical device company in Eden Prairie and was assigned to a regulatory meeting in Munich with twelve days notice. My passport was expired. Fast Passport Center had my renewal processed in five business days. I made the meeting and closed the deal. Their document review caught a form error I would have missed entirely.",
    service: "Passport Renewal",
  },
  {
    name: "The Martinez Family",
    location: "Near Purgatory Creek, Eden Prairie",
    rating: 5,
    text: "We booked a European river cruise six weeks out and realized our daughter's passport had expired. Fast Passport Center walked us through the child renewal process, reviewed every document, and got her passport back in six business days. We sailed on schedule. Cannot recommend them enough.",
    service: "Child Passport",
  },
  {
    name: "Lisa H.",
    location: "Prairie Center Drive Area, Eden Prairie",
    rating: 5,
    text: "I had a technology partnership meeting in Singapore and discovered my passport was expired. Called Fast Passport Center, shipped overnight from the Eden Prairie FedEx, and my renewed passport arrived Thursday for a Monday flight. Professional, efficient, and exactly as fast as promised.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function EdenPrairieTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Eden Prairie &amp; Southwest Metro Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Eden Prairie, Chanhassen, and southwest metro travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}